import React from 'react'

export default function Stars(props) {
    let numStars = props.showStars;
    for(let i = 0; i<=numStars; i++){
        return (
            <>
                <span className="bds-featureRating__stars" key={i}><span></span></span>
                <span className='d-none'>{i++}</span>
            </>
        )
    }
}
